import { jsx as _jsx } from "react/jsx-runtime";
const Download = () => (_jsx("svg", Object.assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.49999 12.24L3.95999 8.71L4.66999 8L6.99999 10.33V0H7.99999V10.33L10.33 8L11.04 8.71L7.49999 12.24ZM0 15H15V16H0V15Z" }) })));
Download.iconName = "download";
Download.iconCategory = "Actions";
export default Download;
